import React from 'react';
import { Col, FormGroup, Label, Input, Row } from 'reactstrap';
import { Trash2 } from 'react-feather';
import RichEditor from 'Component/Editor/RichEditor/RichEditor';

/**
 * Render rows untuk tipe: multiple_choice
 * - Left: RichEditor untuk Pilihan Jawaban
 * - Right: radio Benar/Salah untuk Nilai
 */
export default function MultipleChoiceRows(props) {
  const {
    answers,
    stateChoiceFromRedux,
    handleChangeChoice,
    handleChangeAnswer,
    handleRemoveOption,
    isAnswerLocked = false,
  } = props;

  const lockedAnswerStyle = isAnswerLocked
    ? { pointerEvents: 'none', opacity: 0.72 }
    : undefined;

  return (
    <>
      {answers.map((option, index) => (
        <Row key={index}>
          <Col className="col-10">
            <FormGroup className="mb-3">
              <Label for={`validationChoice-${index}`} style={{ fontWeight: 'bold' }}>
                {'Pilihan Jawaban'}:
              </Label>

              {/* RichEditor existing behavior: parent passes index separately */}
              <RichEditor
                key={index}
                id={`validationChoice-${index}`}
                handleChangeDescription={handleChangeChoice}
                description={stateChoiceFromRedux[index]}
                index={index}
              />
            </FormGroup>
          </Col>

          <Col className="col-2">
            <FormGroup className="mb-3" style={lockedAnswerStyle} aria-disabled={isAnswerLocked || undefined}>
              <Label style={{ fontWeight: 'bold' }}>
                {'Nilai'}:{' '}
                {index > 0 && !isAnswerLocked && (
                  <Trash2 onClick={() => handleRemoveOption(index)} color="red" />
                )}
              </Label>

              <div className="m-checkbox-inline">
                <Label for={`answer_false-${index}`}>
                  <Input
                    className="radio_animated"
                    id={`answer_false-${index}`}
                    type="radio"
                    name={`answer-${index}`}
                    value="0"
                    checked={option == '0' || false}
                    disabled={isAnswerLocked}
                    onChange={(e) => handleChangeAnswer(e, index, 'answer')}
                  />
                  {'Salah'}
                </Label>

                <Label for={`answer_true-${index}`}>
                  <Input
                    className="radio_animated"
                    id={`answer_true-${index}`}
                    type="radio"
                    name={`answer-${index}`}
                    value="1"
                    checked={option == '1' || false}
                    disabled={isAnswerLocked}
                    onChange={(e) => handleChangeAnswer(e, index, 'answer')}
                  />
                  {'Benar'}
                </Label>
              </div>
            </FormGroup>
          </Col>
        </Row>
      ))}
    </>
  );
}